import React, { FC, useState, useEffect } from "react"
import { Button, Empty, Layout, Modal, Row, Select, Table, Tabs, Tag, Typography } from "antd"
import { SettingOutlined } from "@ant-design/icons"
import { HeaderText } from "../common/HeaderText"
import { Match } from "../../models/Match"
import { defaultColumns } from "../../models/miscellaneous/MiscellaneousStatDefaultColumns"
import { columns } from "../../models/miscellaneous/MiscellaneousStatColumns"
import { PointSystem } from "../../models/leaderboards/PointSystem"
import { pointSystem as testPointSystem } from "../../models/test/SolosPointSystem"
import { columns as defaultLeaderboardColumns } from "../../models/leaderboards/LeaderboardColumns"

const { Header, Content } = Layout
const { TabPane } = Tabs
const { Text } = Typography

defaultLeaderboardColumns.push()

export interface BonusComponentProps {
    bonusMatches?: Array<Match>
    pointSystem?: PointSystem
}

export const BonusComponent: FC<BonusComponentProps> = (props) => {
    const [pointSystem, setPointSystem] = useState<PointSystem>(testPointSystem)
    const [bonusMatches, setBonusMatches] = useState<Array<Match>>([])
    const [columnSettings, setColumnSettings] = useState<Array<any>>(defaultColumns)
    const [leaderboardColumns] = useState<Array<any>>(defaultLeaderboardColumns)
    const [isColumnSettingModalVisible, setIsColumnSettingModalVisible] = useState<boolean>(false)

    useEffect(() => {
        if (props.bonusMatches !== undefined) {
            setBonusMatches(props.bonusMatches)
        }

        if (defaultLeaderboardColumns.length === 6) {
            defaultLeaderboardColumns.splice(4, 0, 
                {
                    title: "Damage",
                    dataIndex: "damage",
                    key: "damage",
                    sorter: {
                        compare: (a: any, b: any) => a.damage - b.damage,
                    },
                    sortDirections: ['descend', 'descend'],
                    render: (damage: number) => damage?.toFixed(2)
                })
        }
    }, [props.bonusMatches])

    useEffect(() => {
        if (props.pointSystem !== undefined) {
            setPointSystem(props.pointSystem)
        }
    }, [props.pointSystem])

    const handleColumnSettingClick = () => {
        setIsColumnSettingModalVisible(true)
    }

    const handleColumnSettingModalCancel = () => {
        setIsColumnSettingModalVisible(false)
    }

    const handleColumnSettingModalOk = () => {
        setIsColumnSettingModalVisible(false)
    }

    const displayColumnOptions = (defaultColumns: Array<any>) => {
        const options: Array<any> = [];

        defaultColumns.forEach((column) => {
            const title = column["title"]
            options.push({
                value: title
            })
        })
        return options;
    }


    function handleColumnSelect(selectedColumns: Array<string>) {
        const displayColumns: Array<any> = [];
        columns.forEach((column) => {
            if (selectedColumns.includes(column.title)) {
                displayColumns.push(column)
            }
        })
        setColumnSettings(displayColumns)
    }

    const leaderboardPoints = (match: Match) => {
        const matchPlacement: Array<any> = JSON.parse(JSON.parse(JSON.stringify(match.placement)))

        const matchPlacementStats: Array<any> = []
        matchPlacement.forEach((team: any) => {
            var placementPoint = 0
            const placement: Array<any> = pointSystem.placements.filter(placement => { return placement.placement === team.rank })
            if (placement.length === 1) {
                placementPoint = placement[0].points
            }
            const killPoints = (team.kills * pointSystem.kills)
            const totalPoints = killPoints + placementPoint
            console.log(team)
            matchPlacementStats.push({
                key: team.players,
                players: team.players.map((player: string) => { return <Tag key={match.matchid + player}>{player}</Tag> }),
                placement: team.rank,
                placementPoints: placementPoint,
                kills: team.kills,
                damage: Number(team.damage),
                killPoints: killPoints,
                totalPoints: totalPoints
            })
        })
        return matchPlacementStats
    }

    const displayBonusMatches = (matches: Array<Match>) => {
        if (bonusMatches.length === 0) {
            return <Empty description={"No bonus matches found."} />
        }

        return matches.map((match: Match) => {
            const matchStats = JSON.parse(JSON.parse(JSON.stringify(match.matchstats)))
            matchStats.forEach((matchStat: any) => {
                matchStat["key"] = matchStat.name
            })
            return (
                <Tabs key={"bonus-tabs"}>
                    <TabPane tab={"Leaderboards"} key="bonus-leaderboards">
                        <Table columns={leaderboardColumns} dataSource={leaderboardPoints(match)} key={match.matchid + "-table"} pagination={false} scroll={{ y: 800 }} />
                    </TabPane>
                    <TabPane tab={"Miscellaneous Stats"} key="bonus-miscellaneous">
                        <Table columns={columnSettings} dataSource={matchStats} scroll={{ y: 800 }} pagination={false} />
                    </TabPane>
                </Tabs>
            )
        })
    }

    return (
        <>
            <Layout>
                <Header>
                    <Row justify="space-between" align="middle" >
                        <HeaderText title={"Bonus Match"} />
                        <Button icon={<SettingOutlined />} size="large" onClick={handleColumnSettingClick}>Miscellaneous Columns</Button>
                    </Row>
                </Header>
                <Content>
                    {displayBonusMatches(bonusMatches)}
                </Content>
            </Layout>
            <Modal
                visible={isColumnSettingModalVisible}
                title={"Select Miscellaneous Stats to View"}
                bodyStyle={{ height: 600 }}
                onCancel={handleColumnSettingModalCancel}
                onOk={handleColumnSettingModalOk}>
                <Text strong style={{ fontSize: 24 }}>Selected</Text>
                <Select defaultValue={defaultColumns.map((column) => { return column.title })} mode={"multiple"} placeholder={"Select Columns"} options={displayColumnOptions(columns)} onChange={(newValue) => { handleColumnSelect(newValue) }} />
            </Modal>
        </>
    )
}